import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-buy-car-details',
    templateUrl: './buy-car-details.component.html',
    styleUrls: ['./buy-car-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuyCarDetailsComponent {

  businessLine: CarBusinessLine = CarBusinessLine.BUY;

}
